import styled from 'react-emotion'

import Colors from '../../../themes/Colors'
import { mobile } from '../../../utils/mixins'
import { Typo18GainsBoroDR } from '../../../themes/Fonts/Din2014'

export const SectionContainer = styled('section')`
  background-color: ${Colors.blackDefault};
  padding-top: 60px;
  padding-bottom: 0px;

  ${mobile} {
    padding-top: 40px;
    font-size: 14px;
    padding-bottom: 40px;
  }
`

export const SectionDescription = styled(Typo18GainsBoroDR)`
  line-height: 1.67;
  letter-spacing: normal;
  padding-top: 14px;
  width: 86.3%;
  margin-bottom: 40px;

  ${mobile} {
    width: 100%;
    margin-bottom: 0px;
    padding-top: 21px;
    font-size: 14px;
    line-height: 1.57;
  }
`

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/ExperimentalMarketingSection/styledComponents.js